/**
 * Theme-related shared types.
 *
 * The full token catalogue and concrete themes live in `@astral/theme`.
 * This module only holds the primitive identifiers that cross the
 * client/server boundary (e.g. persisted user preferences).
 */

/**
 * Theme mode chosen by the user.
 *  - dark   : always dark
 *  - light  : always light
 *  - auto   : follow the Telegram / system color scheme
 *  - custom : reserved — user-defined theme (architecture ready, not exposed yet)
 */
export const THEME_MODES = ['dark', 'light', 'auto', 'custom'] as const;

export type ThemeMode = (typeof THEME_MODES)[number];

export const DEFAULT_THEME_MODE: ThemeMode = 'dark';

/** Identifier of the active theme definition (e.g. "astral-rose"). */
export type ThemeId = string;

export const DEFAULT_THEME_ID: ThemeId = 'astral-crimson';

export function isThemeMode(value: unknown): value is ThemeMode {
  return typeof value === 'string' && (THEME_MODES as readonly string[]).includes(value);
}
